import {z} from "zod"

export const definition = {
    validation: {
        returns: z.any(),
        parameters: z.object({
            args: z.any(),
            fn: z.function().args(z.any()).returns(z.any()),
        }),
    },
}
